import { Component, Injector, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { InfoOption } from '@app/forms/subscription/components/info/info.component';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { paymentPrimesOptions } from '@app/forms/subscription/services/ref';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
    selector: 'risques-distribution',
    templateUrl: './risques-distribution.component.html',
    styleUrls: ['./risques-distribution.component.scss'],
    standalone: false
})
export class RisquesDistributionComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  optionInfo1: InfoOption = {
    icon: 'warning',
    backgroundColor: '#fae4e4',
    iconColor: '#a00d0d',
    textColor: '#a00d0d',
  };
  options: FormControlOption[] = paymentPrimesOptions;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
